<template>
  <div v-if="eventCards && eventCards.length" class="upcoming-leagues">
    <div class="grid__row">
      <div class="grid__column grid__column--12">
        <HeaderContent type="primary" direction="coilumn-">
          <template #primary-left>
            <router-link :to="{ name: eventsRouteNames.Events, query: { types: leagueTypeId } }">
              <USButton type="inline" label="View All" />
            </router-link>
          </template>
          <template #primary-right>
            <h2 class="upcoming-events__heading heading--h3">
              Upcoming Leagues
            </h2>
          </template>
        </HeaderContent>
      </div>
    </div>
    <CardRow :cards="eventCards" />
  </div>
</template>

<script lang="ts" setup>
import { getEvents } from '__generated__/getEvents'
import { getEvent_getEvent_GetEventOutput_event } from '__generated__/getEvent'
import { EventSortField, SortOrder } from '__generated__/globalTypes'
import { eventAttributesTypes } from '__generated__/eventAttributesTypes'

import { defineComponent, ref } from 'vue'

import { Card, CardType } from '@base/_types/Card'

import { createSlug } from '@base/lib/createSlug'

import CardRow from '@base/components/CardRow/CardRow.vue'
import HeaderContent from '@base/components/HeaderContent/HeaderContent.vue'
import USButton from '@base/components/USButton/USButton.vue'

import { useClient } from '@base/api/useClient'
import { ugcImageSrc } from '@base/lib/ugcImageSrc'

import { LIST_EVENTS } from '@player/events/api/queries/listEvents'
import { EVENT_ATTRIBUTES_TYPES } from '@player/events/api/queries/eventAttributesTypes'

import { eventsRouteNames } from '@player/events/router/routeNames'

import imageEventPlaceHolder from '@player/_assets/event-placeholder.jpg'

defineComponent({
  name: 'UpcomingEvents',
  components: {
    CardRow,
    HeaderContent,
    USButton
  }
})

const client = useClient()
const events = ref<getEvent_getEvent_GetEventOutput_event[]>([])
const eventCards = ref<Card[]>([])
let leagueTypeId: string

const formatCards = () => {
  events.value.forEach((event) => {
    if (event.club.__typename === 'GetClubOutput') {
      eventCards.value.push({
        type: CardType.CardEvent,
        data: {
          eventName: event.name,
          clubName: event.club.club?.clubName || '',
          eventDate: new Date(event.dateStart),
          image: {
            src:
              event.gallery && event.gallery[0]
                ? ugcImageSrc(event.gallery[0] || '')[0]
                : imageEventPlaceHolder
          },
          exclusive: event.exclusive || false,
          to: {
            name: eventsRouteNames.EventSingle,
            params: {
              slug: createSlug(event.name, event.slug)
            }
          }
        }
      })
    }
  })
}

const fetchData = async () => {
  try {
    events.value = []

    let { data: fetchEventTypes } = await client.query<eventAttributesTypes>({
      query: EVENT_ATTRIBUTES_TYPES,
      fetchPolicy: 'no-cache'
    })

    if (fetchEventTypes.fetchEventTypes.__typename === 'AttributesOutput') {
      fetchEventTypes.fetchEventTypes.attributes.forEach((item) => {
        if (item.name.toLowerCase().includes('league')) {
          leagueTypeId = item.id
        }
      });
    }

    const { data } = await client.query<getEvents>({
      query: LIST_EVENTS,
      variables: {
        filter: {
          dateStartAfter: new Date(new Date().setHours(0, 0, 0)),
          eventType: leagueTypeId
        },
        sort: {
          sortField: EventSortField.DATE_START,
          sortOrder: SortOrder.ASC
        },
        limit: 10
      },
      fetchPolicy: 'no-cache'
    })

    if (data.listEvents.__typename !== 'ListEventsOutput') {
      return
    }

    events.value = data.listEvents.events

    formatCards()
  } catch (e) {
    console.error(e)
  }
}


await fetchData()
</script>

<style lang="scss" scoped>
.upcoming-leagues {
  margin-bottom: var(--spacing--template);
  padding-bottom: var(--spacing--3);
  background-color: var(--color--secondary-c2);
  clip-path: ellipse(125% 50% at 50%);
}
</style>
